import { BrandingSettings, User } from '@interfaces';

export type UserAuthLoginStep = 'CREDENTIALS' | 'MFA';

export type UserAuthState = Readonly<{
  loading: boolean;
  myself: null | User;
  errorMessage: string | null;
  loginStep: UserAuthLoginStep;
  pendingLoginId: string | null;
  maskedPhoneNumber: string | null;
  mfaErrorMessage: string | null;

  loadingBranding: boolean;
  branding: BrandingSettings | null;
}>;

export const initialState: UserAuthState = {
  loading: false,
  myself: null,
  errorMessage: null,
  loginStep: 'CREDENTIALS',
  pendingLoginId: null,
  maskedPhoneNumber: null,
  mfaErrorMessage: null,

  loadingBranding: false,
  branding: null,
};
